﻿import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition } from "@mcurros2/microm";
 

const columns = () =>
(
    {
        c_pais_id: new EntityColumn<string>({ name: 'c_pais_id', type: 'char', length: 20, flags: c.PK, prompt: 'País Id' }),
        vc_pais_nombre: new EntityColumn<string>({ name: 'vc_pais_nombre', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre País' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        pais_brwStandard: { name: 'pais_brwStandard', keyMappings: { c_pais_id: 0 } }
    }
)


export class PaisesDef extends EntityDefinition {

    columns = columns();
    views = views();


    constructor() {
        super('Paises');
    }
}